import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

// Constants
import { SKETCH_WEBSITE } from 'constants/sketchWebsite'
import { routes } from 'constants/routes'

// Components
import Button from 'components/Button'

// Styles
import { Banner } from './UpgradePersonalWorkspacePanel.styles'

export interface UpgradePersonalWorkspacePanelProps {
  name: string
}

export const UpgradePersonalWorkspacePanel: React.FC<UpgradePersonalWorkspacePanelProps> = props => {
  const { name } = props
  const history = useHistory()

  const onUpgrade = useCallback(() => {
    history.push(
      routes.WORKSPACE_CREATE.create({
        query: { name, upgrade: 'true' },
      })
    )
  }, [name, history])

  return (
    <Banner
      data-testid="workspace-settings-details"
      title="Subscribe to Get the Best of Sketch"
      text={
        <span>
          You can easily upgrade your legacy Personal Workspace with a{' '}
          <a href={`${SKETCH_WEBSITE}/support/switch-to-a-subscription/`}>
            subscription
          </a>
          , which includes the full suite of collaboration tools and access to
          the Mac app.
          <br />
          <br />
          If you switch to a subscription you can also redeem $9 in credit for
          each remaining month on any non-educational license you own.
        </span>
      }
      action={
        <Button onClick={onUpgrade} variant="primary-untinted" small>
          Switch to Subscription
        </Button>
      }
    />
  )
}
